import React from "react";
import TextInput from "./TextInput";

export default function NumberInput(props) {
  return <TextInput type="number" {...props} />;
}
